import { emptyCart, loadCart } from './shop';
import { basicMsg, htmlMsg, valMsg } from './swal_msg';
import { loginModalToggle, loginCodeModal } from './ui';

import { types } from '../types/types';
import { loginCartContext, receiveLoginCart } from '../helpers/shop/loginCart';
import { protectedReq, request } from "../helpers/requestHelper";
import { clearStoredSession, isAuthSessionError } from '../helpers/sessionHelper';
import { normalizeEmail, isCaptchaError } from '../helpers/security';

const showSecurityError = (body, title) => {
    if (isCaptchaError(body)) return true;
    if (body?.msg === 'rate-limit') {
        const seconds = Number(body.retry_after) || 60;
        valMsg('warning', title, `Demasiados intentos. Intenta de nuevo en ${seconds} segundos.`);
        return true;
    }
    if (body?.msg === 'password-weak') {
        valMsg('warning', title, 'Usa una contraseña más larga y evita datos personales o patrones comunes.');
        return true;
    }
    return false;
};

// registro de usuario
export const signUp = (user_data) => {
    return async(dispatch) => {
        try {
            const { page, ...model } = user_data;
            // token carrito
            const cart_token = localStorage.getItem('cart-token') || '';

            const resp = await request('user/sign-up', {
                ...model, email: normalizeEmail(model.email), cart_token
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { op_msg } = body;
                const {
                    user, token, new_cart_token, cart_data
                } = body.resp;

                localStorage.setItem('token', token);
                localStorage.setItem('token-date', new Date().getTime());

                // carrito de compras no registrado
                if (op_msg.includes('remove-cart'))
                    dispatch(emptyCart());
                else {
                    // datos de carrito
                    dispatch(loadCart(cart_data));
                    if (op_msg.includes('cart-init')) // guardar nuevo token de carrito
                        localStorage.setItem('cart-token', new_cart_token);
                }

                dispatch(loggedIn({ ...user, page }));
            } else if (!showSecurityError(body, 'Registro')) {
                if (body.msg === 'email-exists')
                    valMsg('warning', 'Registro',
                    'Ya existe un usuario con ese correo electrónico');
                else if (body.msg === 'account-not-created') {
                    localStorage.removeItem('token');
                    valMsg('warning', 'Registro',
                    'No se pudo crear la cuenta');
                } else if (body.msg === 'server-err')
                    valMsg('error', 'Registro',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else valMsg('warning', 'Registro',
                    'Inténtelo de nuevo, por favor');
            }
            return body;
        } catch (err) {
            valMsg('error', 'Ocurrió un incidente',
            'No se pudo realizar el registro');
            return { status: false, msg: 'network-error' };
        };
    };
};

// inicio de sesión de usuario
export const login = (user_data) => {
    return async(dispatch, getState) => {
        try {
            const { page, ...model } = user_data;
            // token carrito
            const cart_token = localStorage.getItem('cart-token') || '';

            const resp = await request('user/login', {
                ...model, email: normalizeEmail(model.email),
                cart_token, ...loginCartContext(getState())
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { op_msg } = body;
                const {
                    user, token, new_cart_token, cart_data
                } = body.resp;
                localStorage.setItem('token', token);
                localStorage.setItem('token-date', new Date().getTime());

                // carrito de compras no registrado
                if (op_msg.includes('remove-cart'))
                    dispatch(emptyCart());
                else {
                    // datos de carrito
                    dispatch(receiveLoginCart(cart_data));
                    if (op_msg.includes('cart-init')) // guardar nuevo token de carrito
                        localStorage.setItem('cart-token', new_cart_token);
                }
                
                dispatch(loggedIn({ ...user, page }));
            } else if (!showSecurityError(body, 'Inicio de sesión')) {
                if (body.msg === 'not-found')
                    basicMsg('No pudimos encontrar el usuario');
                else if (body.msg === 'code-sent') {
                    basicMsg('Inicie sesión mediante el código enviado a su correo');
                    dispatch(loginCodeModal(true));
                } else if (body.msg === 'not-logged-in')
                    basicMsg('No pudimos iniciar su sesión');
                else if (body.msg === 'server-err')
                    valMsg('error', 'Inicio de sesión',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else valMsg('warning', 'Inicio de sesión',
                    'Inténtelo de nuevo, por favor');
            }
            return body;
        } catch (err) {
            valMsg('error', 'Inicio de sesión',
            'No se pudo iniciar sesión');
            return { status: false, msg: 'network-error' };
        };
    };
};

export const googleToken = (access_token, expires_in) => {
    return async(dispatch, getState) => {
        try {
            // token carrito
            const cart_token = localStorage.getItem('cart-token') || '';
            const resp = await request('user/google-token', {
                access_token, expires_in, cart_token, ...loginCartContext(getState())
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { op_msg } = body;
                const {
                    user, token, new_cart_token, cart_data
                } = body.resp;
                // token de sesión
                localStorage.setItem('token', token);
                localStorage.setItem('token-date', new Date().getTime());

                // carrito de compras no registrado
                if (op_msg.includes('remove-cart'))
                    dispatch(emptyCart());
                else {
                    // datos de carrito
                    dispatch(receiveLoginCart(cart_data));
                    if (op_msg.includes('cart-init')) // guardar nuevo token de carrito
                        localStorage.setItem('cart-token', new_cart_token);
                }

                dispatch(loggedIn({ ...user, page: 'mi-cuenta' }));
            } else {
                if (body.msg === 'not-found') {
                } else if (body.msg === 'not-match') {
                    valMsg('warning', 'Inicio de sesión',
                    'Intente registrarse con otra cuenta');
                } else if (body.msg === 'server-err') {
                    valMsg('error', 'Inicio de sesión',
                    'Ocurrió un incidente. Intente de nuevo más tarde, por favor');
                } else valMsg('warning', 'Inicio de sesión',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            valMsg('error', 'Inicio de sesión',
            'No se pudo iniciar sesión');
        };
    };
};

export const facebookLogin = (user_data) => {
    return async(dispatch, getState) => {
        try {
            const { page, ...model } = user_data;
            // token carrito
            const cart_token = localStorage.getItem('cart-token') || '';
            const resp = await request('user/facebook-login', {
                ...model, cart_token, ...loginCartContext(getState())
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { op_msg } = body;
                const {
                    user, token, new_cart_token, cart_data
                } = body.resp;
                // token de sesión
                localStorage.setItem('token', token);
                localStorage.setItem('token-date', new Date().getTime());

                // carrito de compras no registrado
                if (op_msg.includes('remove-cart'))
                    dispatch(emptyCart());
                else {
                    // datos de carrito
                    dispatch(receiveLoginCart(cart_data));
                    if (op_msg.includes('cart-init')) // guardar nuevo token de carrito
                        localStorage.setItem('cart-token', new_cart_token);
                }

                dispatch(loggedIn({ ...user, page: 'mi-cuenta' }));
            } else {
                if (body.msg === 'not-found') {
                } else if (body.msg === 'not-match') {
                    valMsg('warning', 'Inicio de sesión',
                    'Intente registrarse con otra cuenta');
                } else if (body.msg === 'server-err') {
                    valMsg('error', 'Inicio de sesión',
                    'Ocurrió un incidente. Intente de nuevo más tarde, por favor');
                } else valMsg('warning', 'Inicio de sesión',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            valMsg('error', 'Inicio de sesión',
            'No se pudo iniciar sesión');
        };
    };
};

// validar token almacenado
export const initLoading = (first_loading) => {
    // first_loading = verifica sesión de usuario (primer comprobación)
    return async(dispatch) => {
        try {
            // token carrito
            const cart_token = localStorage.getItem('cart-token') || '';
            const had_user_token = Boolean(localStorage.getItem('token'));
            const resp = await protectedReq('user/renew', { first_loading, cart_token }, 'POST');
            const body = await resp.json();
            if(body.status) {
                const { front_state } = body;
                const { token, new_cart_token, ...user } = body.resp;

                // guardar token de carrito
                if (first_loading && front_state &&
                    front_state.includes('cart-init')
                )
                    localStorage.setItem('cart-token', new_cart_token);

                // eliminar token de carrito
                if (first_loading && front_state &&
                    front_state.includes('remove-cart')
                )
                    localStorage.removeItem('cart-token');
                
                // guardar sesión de usuario
                localStorage.setItem('token', token);
                localStorage.setItem('token-date', new Date().getTime());
                dispatch(loggedIn({ ...user, page: 'mi-cuenta' }));
            } else {
                const { front_state } = body;
                const { new_cart_token = '' } = body.resp || {};

                if (first_loading && front_state &&
                    front_state.includes('cart-init')
                )
                    localStorage.setItem('cart-token', new_cart_token);
                
                if (first_loading && front_state &&
                    front_state.includes('remove-cart')
                )
                    localStorage.removeItem('cart-token');
                
                // Una carga de invitado sin token es normal y puede conservar su carrito.
                // Si había una sesión o la cuenta dejó de existir, se limpia por completo.
                if (body.msg === 'account-not-found' ||
                    (had_user_token && isAuthSessionError(body.msg)))
                    dispatch(logout());
                else
                    dispatch(loadingDone());
            }
        } catch (err) {
            dispatch(loadingDone());
        };
    };
};

// crear sesión
export const loggedIn = (payload) => ({
    type: types.userLoggedIn, payload
});

// limpia local storage, usuario y redirecciona a inicio
export const logout = () => {
    return async(dispatch) => {
        clearStoredSession();
        dispatch(emptyCart());
        dispatch(loggedOut());
    };
};

// cerrar sesión
const loggedOut = () => ({
    type: types.userLoggedOut
});

// token no renovado. Mostrar sitio
const loadingDone = () => ({ type: types.loadingDone });

// envío de correo para restablecer contraseña
export const resetRequest = (email, turnstile_token = '') => {
    return async(dispatch) => {
        try {
            const resp = await request('user/generate-reset-request', {
                email: normalizeEmail(email), turnstile_token
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                valMsg('success', 'Correo enviado',
                    'Se ha enviado un correo electrónico para restablecer su contraseña');
                dispatch(loginModalToggle(false));
            } else if (!showSecurityError(body, 'Envío de correo')) {
                if (body.msg === 'no-user') {
                    valMsg('success', 'Correo enviado',
                    'Se ha enviado un correo electrónico para restablecer su contraseña');
                    dispatch(loginModalToggle(false));
                } else if (body.msg === 'still-valid') {
                    valMsg('warning', 'Solicitud enviada',
                    'Ya se ha enviado un correo electrónico para restablecer su contraseña');
                    dispatch(loginModalToggle(false));
                } else if (body.msg === 'server-err')
                    valMsg('error', 'Envío de correo',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else valMsg('warning', 'Envío de correo',
                    'Inténtelo de nuevo, por favor');
            }
            return body;
        } catch (err) {
            valMsg('error', 'Envío de correo',
            'No se pudo realizar el registro');
            return { status: false, msg: 'network-error' };
        };
    };
};

// recupera solicitud de restablecimiento de contraseña
export const getRequest = (hash) => {
    return async(dispatch) => {
        try {
            const resp = await request('user/reset-request', { hash });
            const body = await resp.json();
            if (body.status) {
                valMsg('success', 'Correo enviado',
                    'Se ha enviado un correo electrónico para restablecer su contraseña');
                dispatch(loginModalToggle(false));
            } else {
                if (body.msg === 'no-user') {
                    valMsg('success', 'Correo enviado',
                    'Se ha enviado un correo electrónico para restablecer su contraseña');
                    dispatch(loginModalToggle(false));
                } else if (body.msg === 'still-valid') {
                    valMsg('warning', 'Solicitud enviada',
                    'Ya se ha enviado un correo electrónico para restablecer su contraseña');
                    dispatch(loginModalToggle(false));
                } else if (body.msg === 'server-err')
                    valMsg('error', 'Envío de correo',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else valMsg('warning', 'Envío de correo',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            valMsg('error', 'Envío de correo',
            'No se pudo realizar el registro');
        };
    };
};

// limpiar página de redirección
export const clearRdrPage = () => ({ type: types.clearRdrPage });

// enviar código de 6 dígitos para inicio de sesión
export const sentLoginCode = async(email, setDialogData, turnstile_token = '') => {
    try {
        const resp = await request('user/sent-code', {
            email: normalizeEmail(email), turnstile_token
        }, 'POST');
        const body = await resp.json();
        if (body.status)
            setDialogData(e => ({
                ...e, sent: true,
                loading1: false,
                title: 'Acceso con código',
                text: 'Ingresa el código de 6 dígitos que recibiste en tu correo electrónico. NO LO COMPARTAS CON NADIE'
            }));
        else {
            setDialogData(e => ({
                ...e, loading1: false
            }));
            if (isCaptchaError(body)) {
                // El diálogo mostrará el widget y conservará el correo capturado.
            } else if (body.msg === 'rate-limit')
                valMsg('warning', 'Código de acceso',
                `Demasiadas solicitudes. Intenta en ${Number(body.retry_after) || 60} segundos.`);
            else if (body.msg === 'miss')
                basicMsg('Introduzca su correo electrónico');
            else if (body.msg === 'account-not-found')
                basicMsg('No hay una cuenta asociada al correo ingresado');
            else if (body.msg === 'too-many-requests')
                htmlMsg('info', 'Código no generado',
                '<p>Has alcanzado el límite de solicitudes por hoy. Podrás volver a generar un nuevo código en 24 horas.</p>');
            else if (body.msg === 'no-req-done')
                valMsg('warning', 'Código de acceso no generado',
                'Intente de nuevo, por favor');
            else if (body.msg === 'email-not-send')
                valMsg('warning', 'Código de acceso no enviado',
                'Intente de nuevo, por favor');
            else if (body.msg === 'server-err')
                valMsg('error', 'Código de acceso',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else basicMsg('Código de acceso no generado');
        }
        return body;
    } catch (err) {
        setDialogData(e => ({
            ...e, loading1: false
        }));
        valMsg('error', 'Código de acceso',
        'No se pudo generar su código de acceso');
        return false;
    };
};

// iniciar sesión mediante código
export const codeLogin = (code, email, page, setDialogData, turnstile_token = '') => {
    return async(dispatch, getState) => {
        try {
            // token carrito
            const cart_token = localStorage.getItem('cart-token') || '';

            const resp = await request('user/code-login', {
                code, email: normalizeEmail(email), turnstile_token,
                cart_token, ...loginCartContext(getState())
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { op_msg } = body;
                const {
                    user, token, new_cart_token, cart_data
                } = body.resp;
                
                localStorage.setItem('token', token);
                localStorage.setItem('token-date', new Date().getTime());
                
                // carrito de compras no registrado
                if (op_msg.includes('remove-cart'))
                    dispatch(emptyCart());
                else {
                    // datos de carrito
                    dispatch(receiveLoginCart(cart_data));
                    if (op_msg.includes('cart-init')) // guardar nuevo token de carrito
                        localStorage.setItem('cart-token', new_cart_token);
                }

                dispatch(loggedIn({ ...user, page }));
            } else {
                if (isCaptchaError(body)) {
                    // El diálogo mostrará Turnstile sin perder el código capturado.
                } else if (body.msg === 'rate-limit')
                    valMsg('warning', 'Acceso mediante código',
                    `Demasiados intentos. Intenta en ${Number(body.retry_after) || 60} segundos.`);
                else if (body.msg === 'no-req-found')
                    basicMsg('Código no es correcto o ha expirado');
                else if (body.msg === 'account-not-found')
                    basicMsg('No se ha encontrado su cuenta');
                else if (body.msg === 'server-err')
                    valMsg('error', 'Acceso mediante código',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    valMsg('warning', 'Acceso mediante código',
                    'No ha iniciado sesión');
            }
            setDialogData(e => ({
                ...e, loading2: false
            }));
            return body;
        } catch (err) {
            valMsg('error', 'Acceso mediante código',
            'No se pudo iniciar sesión');
            setDialogData(e => ({
                ...e, loading2: false
            }));
            return { status: false, msg: 'network-error' };
        };
    };
};
